import { render, staticRenderFns } from "./EpotCreatex.vue?vue&type=template&id=e938bdbe"
import script from "./EpotCreatex.vue?vue&type=script&lang=js"
export * from "./EpotCreatex.vue?vue&type=script&lang=js"
import style0 from "./EpotCreatex.vue?vue&type=style&index=0&id=e938bdbe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports